import React, { useCallback, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { signInStyles } from './style'
import { Box, Checkbox, InputAdornment, IconButton } from '@material-ui/core'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import { AppInput, AppButton, Loader } from '../../Components'
import { TextField, Grid } from '@material-ui/core'
import { useFormik } from 'formik'
import { userSignIn, clearMessage } from '../../AppRedux/actions/Auth'
import { Redirect } from 'react-router-dom'
import * as yup from 'yup'
import DisplayMessage from '../../Components/DisplayMessage'
import { Link } from 'react-router-dom'
import { COMMON } from '../../utils/constants'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import _ from 'lodash'
import ReCAPTCHA from 'react-google-recaptcha'
import { utilService } from '../../Services/UtilService/UtilService'
import { pushToDataLayer, USERBEHAVIOURTRACKING } from '../../utils/gaEnvironment'

const validationSchema = yup.object({
  userEmailId: yup
    .string('Enter your email')
    .email('Enter a valid email')
    .required('Email is required'),
  password: yup
    .string('Enter your password')
    .required('Password is required'),
})

const BAD_CREDS = 'Bad credentials'

function SignInScreen(props) {
  const classes = signInStyles()
  const [open, setOpen] = useState(false)
  const [messageType, setMessageType] = useState('info')
  const [showPassword, setShowPassword] = useState(false)
  const [errorResponse, setErrorResponse] = useState(props.errorResponse)

  let recaptchaInstance
  const formik = useFormik({
    initialValues: {
      userEmailId: '',
      password: '',
      captchaValue: '',
      remember: false,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      props.userSignIn(values)
      pushToDataLayer({ event: USERBEHAVIOURTRACKING })
    },
  })

  const debounceLoginAttempts = useCallback(_.debounce(async (value) => {
    await utilService.getLoginAttemptsDetails(value)
      .then(validatedData => {
        setErrorResponse(validatedData)
      })
      .catch(error => {
        setErrorResponse(null)
      })
  }, 1000), [])

  useEffect(() => {
    if (props.message && props.messageType) {
      setOpen(true)
      setMessageType(props.messageType)
      recaptchaInstance && recaptchaInstance.reset()
      expireCaptcha()
      setErrorResponse(props.errorResponse)
      const clear = setTimeout(() => {
        props.clearMessage()
      }, 6000)
      return () => clearTimeout(clear)
    }
  }, [props.message, props.messageType])

  const handleClose = (event, reason) => {
    if (reason === COMMON.CLICKAWAY) {
      return
    }

    setOpen(false)
    props.clearMessage()
  }

  const onChange = (value) => {
    formik.setFieldValue('captchaValue', value)
  }

  const expireCaptcha = () => {
    formik.setFieldValue('captchaValue', '')
  }

  if (props.authUser) {
    const signedOut = localStorage.getItem('signedOut')
    setTimeout(() => {
      localStorage.removeItem('signedOut')
    }, 3000)
    return <Redirect to={{ pathname: signedOut ? props.currentUser && !props.currentUser.roles.includes('SUPER_ADMIN') && props.currentUser.gsmAccess === 'false' ? '/developer' : '/dashboard' : props.currentUser && !props.currentUser.roles.includes('SUPER_ADMIN') && props.currentUser.gsmAccess === 'false' ? _.get(props, 'location.state.from.pathname', '/developer') : _.get(props, 'location.state.from.pathname', '/dashboard') }} />
  }

  return (
    <>
      <div className={classes.SignInDiv}>
        <Loader loading={props.loading} />
        {props.message && open && <DisplayMessage open={open} message={props.errorResponse && props.errorResponse.message && props.errorResponse.message !== BAD_CREDS ? props.errorResponse.message : props.message} messageType={messageType} handleClose={handleClose} />}
        <Box className={classes.SignInBox}>
          <Box className={classes.SignInTextBox}>
            <p>Sign In</p>
          </Box>
          <hr />
          <form onSubmit={formik.handleSubmit}>
            <Box className={classes.container}>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    name="userEmailId"
                    label="Email ID"
                    value={formik.values.userEmailId}
                    onChange={(e) => {
                      if (e.target.value) {
                        debounceLoginAttempts.cancel()
                        debounceLoginAttempts(e.target.value)
                      }
                      formik.setFieldValue('userEmailId', e.target.value)
                    }}
                    error={formik.touched.userEmailId && Boolean(formik.errors.userEmailId)}
                    helperText={formik.touched.userEmailId && formik.errors.userEmailId}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    label="Password"
                    value={formik.values.password}
                    inputProps={{
                      autoComplete: showPassword ? 'off' : 'new-password',
                    }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword((show) => !show)}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>,
                    }}
                    onChange={formik.handleChange}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                  />
                </Grid>
              </Grid>
              <Box className={classes.flexSpaceBtw}>
                <label>
                  <Checkbox
                    name="remember"
                    color="primary"
                    values={formik.values.remember}
                    onChange={formik.handleChange}
                    size="small"
                    icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  />
                  Remember me
                </label>

                <Link to={{ pathname: '/forgot-password' }} className={classes.forgotPassword}> Forgot Password </Link>
              </Box>
              {(errorResponse && errorResponse.continuous_unsuccessful_attempts && errorResponse.continuous_unsuccessful_attempts > 0) &&
                <ReCAPTCHA
                  ref={e => recaptchaInstance = e}
                  sitekey="6LfoHdQUAAAAALAZcE7V8zKyZb2lZGrWRcIKT2yg"
                  onChange={onChange}
                  onExpired={expireCaptcha}
                />
              }
            </Box>
            <AppButton type="submit" text="SIGN IN" />
            <br /><br />
            <hr />
            <Box className={classes.container}>
              <p>
                If you do not have an account and would like to apply to be a Enphase Grid Partner, please click the “Sign Up” below.
              </p>
              <AppButton text="SIGN UP" fill={false} onClick={() => props.history.push('/signup')} />
            </Box>
          </form>
        </Box>
      </div>
    </>)
}

const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser, message, messageType, errorResponse, loading } = auth
  return { authUser, currentUser, message, messageType, errorResponse, loading }
}

const mapDispatchToProps = dispatch => ({
  userSignIn: payload => dispatch(userSignIn(payload)),
  clearMessage: () => dispatch(clearMessage())
})

export default connect(mapStateToProps, mapDispatchToProps)(SignInScreen)